export enum AuthEventCode {
  TOKEN_REFRESHED = 'token_refreshed',
  TOKEN_REFRESH_ERROR = 'token_refresh_error',
}
